import React from "react";
import { Link } from "react-router-dom";
import DashboardPreview from "./DashboardPreview";
import { Check, ArrowRight, Sparkles } from "./Icons";

const FEATS = [
  {
    forte: "ETL automatizado",
    resto: "ingerindo dados do CRM Vista em um data store próprio.",
  },
  {
    forte: "10 módulos de BI",
    resto: "metas, funis, forecast ponderado e inteligência de perdas.",
  },
  {
    forte: "Chatbot no WhatsApp",
    resto: "com IA, mensagens de voz (Whisper) e RAG sobre o catálogo.",
  },
  {
    forte: "100% white-label",
    resto: "temas, módulos ativáveis e identidade configuráveis em runtime.",
  },
];

const TAGS = [
  "Next.js 16",
  "TypeScript",
  "Supabase",
  "PostgreSQL + RLS",
  "n8n / ETL",
  "pgvector / RAG",
  "WhatsApp API",
];

function ProjetoDestaque() {
  return (
    <div className="flagship">
      <div className="flagship-grid">
        <div>
          <div className="flagship-tagrow">
            <span className="badge badge-ok">
              <Sparkles width={14} height={14} /> Projeto em destaque
            </span>
            <span className="badge">Business Intelligence</span>
          </div>

          <h3>Dashboard Imobiliário — BI integrado ao CRM &amp; WhatsApp</h3>
          <p>
            Plataforma de inteligência de negócio que transforma os dados
            operacionais de uma imobiliária em métricas de gestão em tempo real.
            Desenvolvi a camada analítica, integrei ao CRM via ETL e construí um
            chatbot de WhatsApp com IA acoplado ao sistema.
          </p>

          <ul className="flagship-feats">
            {FEATS.map((f) => (
              <li key={f.forte}>
                <span className="ic">
                  <Check />
                </span>
                <span>
                  <strong>{f.forte}</strong> — {f.resto}
                </span>
              </li>
            ))}
          </ul>

          <div className="flagship-tags">
            {TAGS.map((t) => (
              <span className="tag" key={t}>
                {t}
              </span>
            ))}
          </div>

          <div className="flagship-cta">
            <Link to="/dashboard-imobiliario" className="btn btn-primary">
              Ver estudo de caso <ArrowRight />
            </Link>
          </div>
        </div>

        <div>
          <DashboardPreview />
        </div>
      </div>
    </div>
  );
}

export default ProjetoDestaque;
